import getDefaultState from './moduleSetupState.js'

export default {
  'SET_CURRENT_USER' (state, userEmail) {
    state.recorded.users[0].emailAddress = userEmail
  },
  'SET_CURRENT_STEP' (state, step) {
    state.view.currentStep = step
  },
  'SET_SETUP_ENTITY_INFO' (state, payload) {
    /*
    entityInfo: docData.entityInfo,
    socialMedia: docData.socialMedia,
    feedbackAddressHandle: docData.feedbackAddressHandle,
    appearanceInfo: docData.appearanceInfo
    */

    state.recorded.businessInfo = payload.entityInfo,
    state.recorded.socialMedia = payload.socialMedia,
    state.recorded.feedbackAddressHandle = payload.feedbackAddressHandle,
    state.recorded.appearance = payload.appearanceInfo

    //REMEMBER TO UPDATE ONLY CURRENT USER'S INFO IN UIDTOENTITY AND ENTITY
    state.recorded.users = [{
      contactNumber: {
        number: payload.userNumber,
        type: payload.userNumberType
      },
      emailAddress: payload.userEmail,
      firstName: payload.userFirstName,
      lastName: payload.userLastName
    }]

    state.view.initialSetup = JSON.stringify(state.recorded)

  },
  'RESET_SIGNUP_STATE' (state) {
    Object.assign(state, getDefaultState())
  },
  'SET_SIGNUP_RECORDED_STATE' (state, payload) {
    // THIS IS DODGY AND MIGHT BREAK SHIT LATER ON??
    if (payload.target.constructor === Array) {
      if (payload.target.length === 1) {
        state.recorded[payload.target[0]] = payload.value
      }
      if (payload.target.length === 2) {
        state.recorded[payload.target[0]][payload.target[1]] = payload.value
      }
      if (payload.target.length === 3) {
        state.recorded[payload.target[0]][payload.target[1]][payload.target[2]] = payload.value
      }
      if (payload.target.length === 4) {
        state.recorded[payload.target[0]][payload.target[1]][payload.target[2]][payload.target[3]] = payload.value
      }
    } else {
      state[payload.target] = payload.value
    }
  }
}
